import { PerformanceEvalEffects } from 'src/app/clinical/store/effects/performance-eval.effects';
import { ClinicalReviewHistoryEffects } from './clinical-review-history.effects';
import { SearchAllClinicalReviewsEffects } from './search-all-clinical-reviews.effects';

export const clinicalEffects = [PerformanceEvalEffects, ClinicalReviewHistoryEffects, SearchAllClinicalReviewsEffects];
